import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { WorkflowdefService } from '@savvy/workflow-definition';
import { ContextService } from '../context.service';
import { ContextIdDto } from '@savvy/app';
import { AddEditWorkflowDialogComponent } from './add-edit-workflow-dialog/add-edit-workflow-dialog.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-workflow-lists',
  templateUrl: 'workflow-list.html'
})
export class WorkflowlistsComponent implements OnInit, OnDestroy {
  contextIdDto: ContextIdDto;
  subscriptions: Subscription[] = [];

  workflowLists: any[] = [];
  columns = [
    { prop: 'name' }
  ];

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private contextService: ContextService,
    private api: WorkflowdefService) { }

  create() {
    const createWorkflowDialogRef = this.dialog.open(AddEditWorkflowDialogComponent, {
      data: {
        contextIdDto: this.contextIdDto
      },
      height: 'auto',
      width: '600px',
    });

    createWorkflowDialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.response) {
        this.getLists();
      }
    });

  }

  onSelect($event) {
    if ($event && $event.selected && $event.selected.length) {
      this.router.navigate(['/workflow/workflow-details',
        $event.selected[0].id
      ]);
    }
  }


  getLists() {
    this.api.getAllWorkflowDefs(this.contextIdDto.contextId, 'ENV_ID').subscribe(
      workflowLists => {
        this.workflowLists = workflowLists.workflowDefinitions;
      });
  }

  ngOnInit() {
    this.subscriptions.push(this.contextService.contextIdDto$.subscribe(data => {
      if (data) {
        this.contextIdDto = data;
        this.getLists();
      }
    }));
  }

  ngOnDestroy() {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

}
